import React from 'react';
import {Route, IndexRoute, Redirect} from 'react-router';
import App from './App';
import Dashboard from './views/dashboard';
import Login from './views/login';
import Questions from './views/questions';
import Reports from './views/reports';
import AuditRegister from './views/auditRegister';
import AuditTracking from './views/auditTracking';
import Page404 from './views/pages/404';
import AutoLogin from "./views/autoLogin"


export default (
    <Route>
           <Route component={Login} exact path='/'/>
          <Route path="autologin" component={AutoLogin} />
        <Route component={App} path='/'>
            <IndexRoute component={Dashboard}/>
            <Route path='dashboard' component={Dashboard}/>
            <Route path='questions' component={Questions}/>
            <Route path='reports' component={Reports}/>
            <Route path='audit-register' component={AuditRegister}/>
            <Route path='audit-tracking' component={AuditTracking}/>

        </Route>
        <Route component={Page404} path='404'/>
        <Redirect from="*" to="404"/>
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js